import DOMPurify from 'dompurify';

/**
 * Sanitize CMS / rich-text HTML before injecting it via
 * `dangerouslySetInnerHTML`.
 *
 * DOMPurify removes XSS vectors — `<script>`, inline event handlers
 * (`onerror`, `onclick`, …), `javascript:` URLs, and similar — while keeping
 * the safe formatting markup that rich-text editors produce. This is our single
 * choke point: every place that renders server/CMS-authored HTML must run it
 * through here so a malicious or compromised content field cannot execute
 * script in a visitor's browser.
 */
export function sanitizeHtml(dirty: string | null | undefined): string {
  if (!dirty) return '';
  return DOMPurify.sanitize(dirty, {
    USE_PROFILES: { html: true },
    ADD_ATTR: ['target', 'rel'],
  });
}

// Force any link that opens in a new tab to also drop the opener reference,
// preventing reverse-tabnabbing from sanitized-but-attacker-authored links.
if (typeof window !== 'undefined') {
  DOMPurify.addHook('afterSanitizeAttributes', (node) => {
    if (node instanceof HTMLElement && node.tagName === 'A' && node.getAttribute('target') === '_blank') {
      node.setAttribute('rel', 'noopener noreferrer');
    }
  });
}
